export default () => {
    return ['/login', '/signup', '/forget-password', '/reset-password', '/', '/content-creator']
}